/**
 * PaymentsPanel — Stripe Connect / pay-now retired (SEC-1).
 * Subscription billing remains under Settings → Billing.
 */
export default function PaymentsPanel() {
  return (
    <div id="payments" className="panel" data-testid="panel-payments" style={{ marginTop: 14 }}>
      <div className="panel-h">
        <div className="panel-tt">Accept payments</div>
        <span className="panel-st">Online invoice payment has been retired</span>
      </div>
      <div className="panel-bp">
        <div
          style={{
            background: 'var(--bg)',
            border: '1px solid var(--line)',
            borderRadius: 'var(--rs)',
            padding: '14px 16px',
            fontSize: 12,
            color: 'var(--ink3)',
            lineHeight: 1.55,
          }}
          data-testid="payments-retired-notice"
        >
          Pay-now links and Stripe Connect onboarding are no longer available. Record payments manually
          on each pay app. Company subscription billing is unchanged — manage it under Billing.
        </div>
      </div>
    </div>
  )
}
